import { makeObservable, observable } from 'mobx'
import Dial from './Dial'

export default class Dialogs {

  dials = []

  queue = []
  currentDial = null

  constructor() {
    makeObservable(this, {currentDial: observable})
  }


  addDialogs(dialogs, gameData) {
    dialogs.forEach(d => {
      if(d.key && !this.dials.find(dial => dial.getKey() === d.key)) {
        this.dials.push(new Dial(d, gameData))
      }
    })
  }

  getAllAttitudes() {
    let attitudes = []

    this.dials.forEach(dial => {
      if(attitudes.indexOf(dial.getAttitude()) === -1)
        attitudes.push(dial.getAttitude())
    })

    return attitudes
  }

  getAttitudes(ids) {
    let attitudes = []

    this.dials.forEach(dial => {

      if(ids.indexOf(dial.getKey()) !== -1 && attitudes.indexOf(dial.getAttitude()) === -1)
        attitudes.push(dial.getAttitude())
    })

    return attitudes
  }

  loadDials(ids) {
    let promises = []

    this.dials.forEach(dial => {
      if(ids.indexOf(dial.getKey()) !== -1)
        promises.push(dial.load(this.dialEnd.bind(this)))
    })
    return Promise.all(promises)
  }

  loadAllDials() {
    let promises = []
    this.dials.forEach(dial => {
      promises.push(dial.load(this.dialEnd.bind(this)))
    })
    return Promise.all(promises)
  }

  getDial(key) {
    return this.dials.find(dial => dial.getKey() === key)
  }

  addDialToQueue(key, cb, characterCb) {
    if(this.queue.length === 0 && this.currentDial === null) {
      this.playDial(this.createDialTempObj(key, cb, characterCb))
    }
    else {
      this.queue.push(this.createDialTempObj(key, cb, characterCb))
    }
  }

  createDialTempObj(key, cb, character) {
    return {
      dial: this.getDial(key),
      cb: cb,

      character: character
    }
  }

  stop() {
    if(this.currentDial && this.currentDial.dial.howl.playing()) {
      this.currentDial.character.stopDial()
      this.currentDial.dial.stop()

      this.currentDial = null
    }
  }

  clearDialQueue() {
    this.queue = []
  }


  playDial(dialTemp) {

    this.currentDial = dialTemp

    if(dialTemp.dial.isLoad) {
      dialTemp.dial.start(this.dialEnd.bind(this))
      dialTemp.character.startDial(dialTemp.dial.howl, dialTemp.dial.getAttitude(), dialTemp.dial.getText(), dialTemp.dial.getPhonem())
    }
    else {
      dialTemp.dial
      .load(() => this.dialEnd())
      .then(() => this.playDial(dialTemp))
    }
  }

  dialEnd() {
    if(this.currentDial && this.currentDial.cb) this.currentDial.cb()

    this.currentDial = null

    this.checkDialQueue()
  }

  checkDialQueue() {
    if(this.queue.length > 0) {
      this.playDial(this.queue.shift())
    }
  }

}